import { useGetWorkspacesQuery, GetWorkspacesQuery } from '@sketch/gql-types'
import { QueryHookOptions } from '@sketch/graphql-apollo'
import { useFlag } from '@sketch/modules-common'

interface UseGetWorkspacesProps
  extends OmitSafe<QueryHookOptions<GetWorkspacesQuery, {}>, 'variables'> {}

const getWorkspaces = (data: GetWorkspacesQuery | undefined) => {
  if (!data?.me) {
    return undefined
  }

  const workspaces = [
    ...(data.me.personalWorkspace ? [data.me.personalWorkspace] : []),
    ...data.me.workspaces,
  ]
  return workspaces
}

export const useGetWorkspaces = (props?: UseGetWorkspacesProps) => {
  // Escape hatch allowing to not request Customer.billing
  // https://github.com/sketch-hq/Cloud/issues/16798
  const shouldIncludeBilling = useFlag('workspaces-dropdown-trial-pill')

  const result = useGetWorkspacesQuery({
    variables: { includeBilling: shouldIncludeBilling },
    ...props,
  })

  const workspaces = getWorkspaces(result.data)

  return { ...result, workspaces }
}
